import { DeltaXMLColors, MyDeltaColors } from './DeltaColors';
import { createMuiTheme, createStyles, Theme, Tooltip, withStyles } from "@material-ui/core";

export class MuiStyles {

    public static theme = createMuiTheme();

    public static appLogoDimensions = {
        height: '70px',
        width: '70px'
    };

    public static LightTooltip = withStyles({
        tooltip: {
            color: DeltaXMLColors.OXFORD_BLUE,
            backgroundColor: DeltaXMLColors.CONCRETE
        }
    })(Tooltip);


  public static HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      maxWidth: 330,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
      fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(','),
      color: MyDeltaColors.WHITE,
      backgroundColor: DeltaXMLColors.OXFORD_BLUE
    },
    arrow: {
      color: DeltaXMLColors.OXFORD_BLUE
    },
  }))(Tooltip);

    public static createPaperBaseStyles(theme: Theme, drawerWidth: number) {
        return createStyles({
            root: {
                display: 'flex',
                minHeight: '100vh',
            },
            drawer: {
                [theme.breakpoints.up('sm')]: {
                    width: drawerWidth,
                    flexShrink: 0,
                },
            },
            app: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
            },
            main: {
                flex: 1,
                padding: theme.spacing(3, 3),
                background: DeltaXMLColors.LIGHT_BACKGROUND,
            },
            main2: {
                flex: 1,
                background: DeltaXMLColors.LIGHT_BACKGROUND,
            },
            footer: {
                padding: theme.spacing(2),
                background: DeltaXMLColors.CONCRETE,
            },
        });
    }

    public static MuiTheme = createMuiTheme({
        palette: {
            primary: {
              light: DeltaXMLColors.CELERY,
              main: DeltaXMLColors.OXFORD_BLUE,
              dark: DeltaXMLColors.CELERY,
            },
            secondary: {
              light: DeltaXMLColors.CELERY,
              main: DeltaXMLColors.OXFORD_BLUE,
              dark: DeltaXMLColors.CELERY,
            }
          },
        typography: {
            /* 
            Compensate for font-size: 62.5% on root-element
            Default size is 16px:
            (0.625 * 16 = 10) 
            */
            htmlFontSize: 10,
            fontFamily: ['Poppins', 'sans-serif'].join(','),
            h1: {
                fontSize: '55px',
                fontWeight: 600,
                lineHeight: '67px'
              },
              h2: {
                fontSize: '40px',
                fontWeight: 600,
                lineHeight: '50px'
              },
              h3: {
                fontSize: '28px',
                fontWeight: 500,
                lineHeight: '39px'
              },
              h4: {
                fontSize: '22px',
                fontWeight: 500,
                lineHeight: '30px',
                color: DeltaXMLColors.CELERY
              },
              h5: {
                fontSize: '20px',
                fontWeight: 400,
                lineHeight: '30px',
              },
              h6: {
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '25px',
                color: DeltaXMLColors.OXFORD_BLUE
              },
              body1: {
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '25px',
                fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')
              },
              body2: {
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')
              }
        },
        shape: {
            borderRadius: 8,
        },
        props: {
            MuiTab: {
                disableFocusRipple: true,
            },
        },
        mixins: {
            toolbar: {
                minHeight: 48,
            },
        },
        overrides: {
            MuiDialog: {
                paperWidthSm: {
                  maxWidth: '1000px',
                }
            },
            MuiDrawer: {
                paper: {
                    backgroundColor: DeltaXMLColors.DARK_BACKGROUND,
                }
            },
            MuiButton: {
                root: {
                    borderRadius: 'none'
                },
                label: {
                    textTransform: 'none',
                },
                contained: {
                    borderRadius: '0',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                    fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(','),
                    boxShadow: 'none',
                    '&:active': {
                      boxShadow: 'none',
                    }
                  },
                containedSecondary: {
                    backgroundColor: 'transparent',
                    border: '1px solid',
                    '&:hover': {
                        // Set hover color
                        backgroundColor: DeltaXMLColors.CELERY,
                        border: '1px solid ' + DeltaXMLColors.CELERY,
                        boxShadow: 'none'
                    }
                },
                containedPrimary: {
                    backgroundColor: 'transparent',
                    color: DeltaXMLColors.OXFORD_BLUE,
                    border: '1px solid',
                    '&:hover': {
                        // Set hover color
                        backgroundColor: DeltaXMLColors.OXFORD_BLUE,
                        color: MyDeltaColors.WHITE,
                        border: '1px solid ' + DeltaXMLColors.OXFORD_BLUE,
                        boxShadow: 'none'
                    }
                }
            },
            MuiTabs: {
                root: {
                    marginLeft: MuiStyles.theme.spacing(1),
                },
                indicator: {
                    height: 3,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    backgroundColor: MuiStyles.theme.palette.common.white,
                },

            },
            MuiTab: {
                root: {
                    textTransform: 'none',
                    margin: '0 16px',
                    minWidth: 0,
                    padding: 0,
                    [MuiStyles.theme.breakpoints.up('md')]: {
                        padding: 0,
                        minWidth: 0,
                    },
                },
            },
            MuiIconButton: {
                root: {
                    padding: MuiStyles.theme.spacing(1),
                },
            },
            MuiTooltip: {
                tooltip: {
                    borderRadius: 4,
                    fontSize: '12px',
                    backgroundColor: DeltaXMLColors.OXFORD_BLUE,
                    color: MyDeltaColors.WHITE
                },
            },
            MuiDivider: {
                root: {
                    backgroundColor: MyDeltaColors.GUN_POWDER,
                },
            },
            MuiListItemText: {
                primary: {
                  fontWeight: 600,
                  fontSize: '14px',
                  lineHeight: '20px',
                  fontFamily: 'Poppins'
                },
              },
            MuiListItemIcon: {
                root: {
                    color: 'inherit',
                    marginRight: 0,
                    '& svg': {
                        fontSize: 20,
                    },
                },
            },
            MuiAvatar: {
                root: {
                    width: 32,
                    height: 32,
                },
            },
            MuiInputBase: {
                root: {
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: DeltaXMLColors.OXFORD_BLUE,
                  fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')
                },
                input: {
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: DeltaXMLColors.OXFORD_BLUE,
                  fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')
                }
              },
              MuiFormControlLabel: {
                label: {
                  color: DeltaXMLColors.OXFORD_BLUE, 
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  fontFamily: ['open-sans', 'HelveticaNeue', 'Helvetica Neue', 'Helvetica-Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',')
                },
        
              },
              MuiTableCell: {
                root: {
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px'
                },
                body: {
                  color: DeltaXMLColors.OXFORD_BLUE
                }
              },
              MuiRadio: {
                colorPrimary: {
                  color: MyDeltaColors.WHITE,
                  '&$checked': {
                    color: DeltaXMLColors.CELERY
                  }
                },
                colorSecondary: {
                  color: DeltaXMLColors.OXFORD_BLUE,
                  '&$checked': {
                    color: DeltaXMLColors.CELERY
                  }
                }
        
              },
        },
    });
}